import { buildClientCard } from '../../shared';

export const buyerCard = buildClientCard({
  id: 'buySideContacts.buyerX',
  entityType: 'client',
  label: 'Buyer',
  showSameAsProperty: false,
});
